<ng-container *ngFor="let palette of palettes">
  <div [class]="'color-swatch ' + palette + ' light'">{{ palette }}</div>
  <div [class]="'color-swatch ' + palette + ' default'">{{ palette }}</div>
  <div [class]="'color-swatch ' + palette + ' dark'">{{ palette }}</div>
</ng-container>
